import { apiClient } from '../client'
import type { ApiResponse } from '../client.types'
import type { SpinWrite, SpinRead, RouletteConfigRead, LimitOffsetPageSpinRead } from '../types'

/**
 * Roulette API endpoints
 * POST /roulette/spin - Execute a spin
 * GET /roulette/spins - Get user spin history
 * GET /roulette/winners/spins - Get winning spins
 * GET /roulette/config - Get roulette configuration
 */

export const rouletteApi = {
  /**
   * Execute a roulette spin
   * POST /roulette/spin
   */
  spin(request: SpinWrite): Promise<ApiResponse<SpinRead>> {
    return apiClient.post<SpinRead>('/roulette/spin', request)
  },

  /**
   * Get user spin history
   * GET /roulette/spins
   */
  getUserSpins(limit = 50, offset = 0): Promise<ApiResponse<LimitOffsetPageSpinRead>> {
    return apiClient.get<LimitOffsetPageSpinRead>('/roulette/spins', { limit, offset })
  },

  /**
   * Get winning spins (public endpoint)
   * GET /roulette/winners/spins
   */
  getWinningSpins(limit = 50, offset = 0): Promise<ApiResponse<LimitOffsetPageSpinRead>> {
    return apiClient.get<LimitOffsetPageSpinRead>('/roulette/winners/spins', { limit, offset })
  },

  /**
   * Get roulette configuration (public endpoint)
   * GET /roulette/config
   */
  getConfig(): Promise<ApiResponse<RouletteConfigRead>> {
    return apiClient.get<RouletteConfigRead>('/roulette/config')
  },
}
